export default class Big3Common {

    static ResultCode = {
        Success: 0,              //Process 처리 성공(저장, 조회, 삭제, 수정 등등)
        Processing: 1,           //처리중
        Error: 2,                //Process 처리 실패
        Warning: 3,              //사용자 경고(메세지..)
        NoSession: 4,            //로그인 되지 않음.
        Exception: 5,            //예외발생
        NonPermission: 6,        //권한 없음.
        Reduplication: 7,        //키 또는 중복값이 발생 하였을때
        ReduplicationLoginID: 8, //아이디 중복
        Retransmission:9,
        Etc: 10,                  //기타
        Etc1: 11,
        Etc2: 12,
    }
    static RoutePotion = {
        Link: 0,
        Layer: 1
    }
    //속성 사전
    static ContentState = {
        BackUrl: "BackUrl",
        LinkUrl:"LinkUrl",
        Uid: "Uid",
        Goods_No: "Goods_No",
        Ordgrp_No:"Ordgrp_No",
        ManCd: "ManCd",
        NotiNo: "NotiNo",
        WUid: "WUid",
        Bld_Code: "Bld_Code",
        Bld_Name: "Bld_Name",
        Flr_Code: "Flr_Code",
        Flr_Name: "Flr_Name",
        Whole_No_Name: "Whole_No_Name",
        Whole_Name: "Whole_Name",
        QstgrpNo: "QstgrpNo",
        QstStatus:"QstStatus",
        SearchText: "SearchText",
        SearchType:"SearchType",
        SearchModel: "",
        FromDate: "FromDate",
        ToDate: "ToDate",
        Page_cd: "Page_cd",
        Mgr_No: "Mgr_No",
        Basket_Yn:"Basket_Yn"
    }
    static AdIndex = {
        NewGoods: "NewGoods",           //오늘의 신상
        BestView: "BestView",           //가장많이본 상품
        WeekBest: "WeekBest",           //주간 베스트
        HostGoods: "HostGoods",         //지금핫한 상품
        SeasonPlan: "SeasonPlan",       //시즌기획전
        SpecialPrice: "SpecialPrice",   //놓치면 후회할 특가상품
        NewWhole: "NewWhole",           //새로운매장 소개
        ClodPick: "ClodPick",           //클로디 픽
        LowPrice: "LowPrice",           //최저가 상품 모아보기
        MyStoreGoods:"MyStoreGoods"     //내거래처 신상 모아보기
    }
    static WebConfig = {
        ImageUpLoadSize: (1024 * 1024 * 4),             //최대 이미지 업로드 사이즈(4Mb)
        BusinessInfoUpLoadSize: (1024 * 1024 * 4),      //사업자등록증 최대 사이즈(4Mb)
        SendFilesize: ((1024 * 1024 * 1)) / 300,        //업로드 전송속도(3500byte전송 단위)
        FileDivision: {                                 //첨부파일 구분
            "BU": "BU",                                 //사업자등록
            "EX": "EX",                                 //대량주문 엑셀
            "GO": "GO",                                 //상품등록
            "PR": "PR"                                  //개인프로필
        },
        FileStoragePath: {                              //첨부파일 경로
            BusinessInfo: "BusinessInfoFilePath",       //사업자 등록증 업로드 정보
            GoodsImageInfo: "GoodsImagePath",           //상품이미지 정보
            Temp: "Temp"
        },
        GoodsImageVirtualPath: () => {
             //상품이지지 가상경로
            let hostname = window.location.hostname;
            if (hostname === "localhost") {
                hostname = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.GoodsImageHostName);
                //return `https://${hostname}/GoodsImage`;
                return "https://platformimg.big3.kr/GoodsImage"
                //return "https://localhost"; 
            }
            else {
                hostname = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.GoodsImageHostName);
                return `https://${hostname}/GoodsImage`;
            }
        },
        EventImageVirtualPath: () => {
            //상품이지지 가상경로
            let hostname = window.location.hostname;
            if (hostname === "localhost") {
                hostname = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.EventImageHostName);
                return "https://deveventimg.big3.kr"
            }
            else {
                hostname = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.EventImageHostName);
                return `https://${hostname}`;
            }
        },
        UpLoadFileType: {
            "Image": "image",
            "File": "file",
            "All": "all"
        },
        Page_Size: 50,
        Sinsale_Count: 2, //낱장구매 가능 개수
        SlidersCount: 3,  //스와이프 표시 개수(노출)
        ScrollEvent: true,   //스크롤이벤트 제어
        LiveChatMsgType: {  //라이브 차트 타입
            Text: "Text",
            Goods: "Goods",
            Order: "Order"
        },
        SimilarRatio: 0.7,
        SimilarUseYn: "N",     //AI 이지미 검색을 통한 상품상세를 보고 있는지 여부
        Similarity_ClickYn:"N"  //상세에서 또 검색을 실행했는지 여부
    }
    //단순파일 업로드 공통설정(SimpleFileUpLoad)
    //Image, File, All
    static BaseFileUpLoadConfig = {
        Blob: false,
        FileType: Big3Common.WebConfig.UpLoadFileType.All,
        FileSize: Big3Common.WebConfig.ImageUpLoadSize,
        UpLoadUrl: "api/Common/Common/FileUpLoad",
        RestUrl: "",
        FileStoragePath: Big3Common.WebConfig.FileStoragePath.Temp
    }
    //현재 값을 변경했는지 확인하는 속성
    //인서트인지, 업데이트인지 구분
    static LifeState = {
        ModelUpDate: false,  
        CRUD: "I"            
    }
    static async Authentication(arg) {
       
        try {
            let data = await this.Get("api/Common/UserInfomation");
            
            if (data.codeName === this.ResultCode.NoSession) {
                //로그인, 회원가입, 비밀번호 찾기는 세션 없이 접근
                if (arg.props.ComponentName !== undefined && arg.props.ComponentName !== null && arg.props.ComponentName !== "") {

                    let Components = JSON.parse(data.multiDataTable)["nosessioncomp"].split(",");
                    let CompName = arg.props.ComponentName;
                    let result = Components.find(element => element === CompName);
                    if (result === undefined) {
                        window.location.href = "/Account/LoginMgr/Index";
                    }
                }
                else {
                    window.location.href = "/Account/LoginMgr/Index";
                }
            }
            else if (data.codeName === this.ResultCode.Exception) {
                window.location.href = "/Account/LoginMgr/Index";
            }
            else if (data.codeName === this.ResultCode.Success) {
                //로그인 된 상태
                //if (Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.IsSecondary) === "Y") {
                //    if (arg.props.ComponentName !== undefined && arg.props.ComponentName !== null && arg.props.ComponentName !== "") {
                //        let CompName = arg.props.ComponentName;
                //        let SubmemberRole = JSON.parse(data.multiDataTable)["submemberrole"];
                //        if (SubmemberRole !== undefined && SubmemberRole !== null && SubmemberRole.length > 0) {
                //            let result = SubmemberRole.find(element => element.compnt_nm.toLowerCase() === CompName.toLowerCase());
                //            if (result === undefined) {
                //                window.location.href = "/NoAuthencation";
                //            }
                //        }
                //        else {
                //            window.location.href = "/NoAuthencation";
                //        }

                //    }
                //    else {
                //        //권한없음 페이지 이동
                //        window.location.href = "/NoAuthencation";
                //    }
                //}
            }
        }
        catch (e) {
            window.location.href = "/Account/LoginMgr/Index";
        }
                        
        return false;
    }
    //bootstrap 모달 오픈
    static ModalAlert(Bootstrap, ModalId, Option) {

        const OpenModal = new Bootstrap.Modal(document.getElementById(`${ModalId}`), {});
        OpenModal.show();
        return false;
    }
    //bootstrap 모달 Close
    static ModalClose(Bootstrap, ModalId,) {
        var CloseModal = document.getElementById(`${ModalId}`);
        var modal = Bootstrap.Modal.getInstance(CloseModal) // Returns a Bootstrap modal instance
        modal.hide();
        return false;
    }
    //첨부파일 다운로드
    static FileDownLoad(Url, fileName) {
        const authHeader = "Bearer Big3Platform************";
        const options = {
            headers: {
                Authorization: authHeader
            }
        };
        fetch(Url, options)
            .then(res => res.blob())
            .then(blob => {
                if (blob.type === "application/json") {
                    alert("파일이 존재하지 않습니다.");
                    return false;
                }
                else {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            });
    }
    //Web Api Get 메소드 호출
    static async Get(uri) {
        try {
            const response = await fetch(uri);
            const result = await response.json();
            return result;
        }
        catch (e) {
            console.log("Get==>", e);
        }   
    }
    //Web Api Post 메소드 호출 
    static async Post(uri, jsonObject, toLowerCase = false) {
        try {
            
            let StringJson = JSON.stringify(jsonObject);
            if (toLowerCase === true) {
                let JsonObj = JSON.parse(StringJson, function (prop, value) {
                    var lower = prop.toLowerCase();
                    if (prop === lower) return value;
                    else this[lower] = value;
                });
                StringJson = JSON.stringify(JsonObj);
            }           
            
            const response = await fetch(uri, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: StringJson
            });
            const result = await response.json();
            return result;
        }
        catch (e) {
            console.log("Post==>", e);
        }
    }
    //이미지 유사도 검색 Post 전송(URL과 X-Api-Key는 하드코딩)
    static async SimilarPost(imageData,imageType="image") {
        try {

            const response = await fetch('https://api.dalpha.so/partner/response/biguncle-image-retrieval/biguncle', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Api-Key': '$2a$10$BR4.W.wsVJRK8o96vYIIquft63gb5ny/dxdWsWJBWl5UX/6YhKcXO'
                },
                body: JSON.stringify({
                    [imageType]: imageData
                })
            });
            if (response.ok) {
                const result = await response.json();
                return {
                    status: response.ok,
                    Data: result.payload.similar_items
                };
            } else {
                console.error('Error:', response.status, response.statusText);
                return {
                    status: false
                };
            }   
        }
        catch (e) {
            console.log("Post==>", e);
        }
    }
    //입력폼 상태값 변경==> 입력값이 변경 될때 State값 변경
    //Big3Common.ValueCahage_StateUpdate({ this:this, event: event, modelName: "memberModel"});
    static ValueCahage_StateUpdate(jsonStructure) {
        try {
            let attribute = {
                this: null,
                event: null,
                modelName: "",
                format:""
            };

            let Merge = Object.assign(attribute, jsonStructure);
            const _this = Merge.this;
            const event = Merge.event;
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;  //체크박스는 여러건을 선택 함으로 object에 id할당하여 처리
            const targetid = target.type === 'radio' ? target.name : target.id;        //radio는 단일건 선택 함으로 object에 name할당하여 처리
            const modelName = Merge.modelName;

            const _model = _this.state[modelName];
            _model[targetid] = value;

            _this.setState({
                [modelName]: _model
            });
        }
        catch (e) {
            console.log("ValueCahage_StateUpdate==>", e);
        }
        Big3Common.LifeState.ModelUpDate = true;
        return false;
    }
    //State내의 특정 모델에 하나, 둘 이상의 특정 값만 변경해야 할 경우
    //모델 속성이 추가 되었을 경우 기존 모델이 추가된 속성이 더해짐.
    //대소문자를 구분함.
    //Big3Common.updateStateModel({ this:this, modelName: "memberModel",updateModel:{"key1":"value1","ke2":"value2"}});
    static updateStateModel(jsonStructure) {

        try {
            const _this = jsonStructure.this;
            const modelName = jsonStructure.modelName;
            const updateModel = jsonStructure.updateModel;
            const targetModel = _this.state[jsonStructure.modelName];
            let MergeModel = Object.assign(targetModel, updateModel);
            _this.setState({
                [modelName]: MergeModel
            });
        }
        catch (e) {
            console.log("updateStateModel==>",e);
        }
        Big3Common.LifeState.ModelUpDate = true;
        return false;
    }
    //state의 Model리스트에 조회한 리스트값 할당
    //ChangeModelInfo는 해당 모델의 속성값 즉, 대소문자가 다를때 등록, ChangeModelInfo의 속성값으로 맞춰줌
    //Big3Common.setBindModel({ this: this, modelName: "memberModel", bindModel: dtList.memberInfo},ChangeModelInfo);
    static setBindModel(jsonStructure, ChangeModelInfo=null) {

        try {
            let attribute = {
                this: null,
                modelName: "",
                bindModel: null
            };
            let Merge = Object.assign(attribute, jsonStructure);            
            if (Merge.modelName !== "") {
                
                const _this = Merge.this;
                const modelName = Merge.modelName;
                let model = _this.state[modelName];
                //model:{key:value,ke2:value}
                if (ChangeModelInfo === null && model.length === undefined) {
                    let bindModel = Merge.bindModel.length === undefined ? Merge.bindModel : Merge.bindModel[0];
                    Object.keys(model).map(key => {
                        let lowerKey = key.toLowerCase();
                        if (bindModel.hasOwnProperty(lowerKey)) {
                            let value = bindModel[lowerKey];
                            model[key] = value;
                        }
                        return model;
                    });
                }
                else if (ChangeModelInfo === null && model.length !== undefined) {
                    //대소분자 변경 없이 리스트 바인딩
                    //model:[{key:value,ke2:value},{key:value,ke2:value}]                    
                    Object.assign(model, Merge.bindModel);
                }
                else {
                    //Json Collection 할당, 사용하는 속성 이름에 대소문자 변경 [{"key":"1"},{"key","2"}]
                    let bindModel = Merge.bindModel;
                    bindModel.map((list) => {
                        let changeJson = Big3Common.Util.Cloen(ChangeModelInfo);
                        Object.keys(ChangeModelInfo).map(key1 => {
                            let lowerKey1 = key1.toLowerCase();
                            Object.keys(list).map(key2 => {
                                let lowerKey2 = key2.toLowerCase();
                                if (lowerKey1 === lowerKey2) {
                                    changeJson[key1] = list[key2];
                                }
                                return true;
                            });
                            return true;
                        });
                        model.push(changeJson);
                        return changeJson;
                    });
                }
            }
            
        }
        catch (e) {
            console.log("setBindModel==>", e);
        }        
        return false;
    }
    //state값을 props.ContentState로 이동 최초 페이지에 돌아 왔을때 다시 바인딩 해주는 함수
    static setContentStateBind(_this) {
        let State = _this.state;
        let ContentState = _this.props.ContentState;
        if (ContentState == null) return false;
        
        Object.keys(State).map(key => {
            if (ContentState.hasOwnProperty(key)) {
                if (ContentState[key] !== null) {
                    if (ContentState[key].length !== undefined && ContentState[key].length > 0) {
                        //key:[{key:value,key:value},{key:value,key:value}]
                        State[key] = ContentState[key];
                    }
                    else {
                        let SingleJson = ContentState[key];
                        let ObjectList = Object.keys(SingleJson);
                        //key:{key:value,key:value}
                        if (ObjectList.length > 0) {
                            let jsonData = {};
                            ObjectList.map(key2 => {
                                return jsonData[key2] = SingleJson[key2];
                            });
                            this.updateStateModel({ this: _this, modelName: key, updateModel: jsonData });
                        }
                        else {
                            //key:value
                            _this.setState({
                                [key]: ContentState[key]
                            });
                        }

                    }
                }
            }
            return false;
        });
        _this.forceUpdate();
        return new Promise(resolve => {
            resolve(true);
        });
        
    }
    
    
    //Guid 생성함수
    //Big3Common.getGuid()
    static getGuid() {
        let crypto = window.crypto || window.msCrypto || null; // IE11 fix

        let Guid =(function () {

            var EMPTY = '00000000-0000-0000-0000-000000000000';

            var _padLeft = function (paddingString, width, replacementChar) {
                return paddingString.length >= width ? paddingString : _padLeft(replacementChar + paddingString, width, replacementChar || ' ');
            };

            var _s4 = function (number) {
                var hexadecimalResult = number.toString(16);
                return _padLeft(hexadecimalResult, 4, '0');
            };

            var _cryptoGuid = function () {
                var buffer = new window.Uint16Array(8);
                window.crypto.getRandomValues(buffer);
                return [_s4(buffer[0]) + _s4(buffer[1]), _s4(buffer[2]), _s4(buffer[3]), _s4(buffer[4]), _s4(buffer[5]) + _s4(buffer[6]) + _s4(buffer[7])].join('-');
            };

            var _guid = function () {
                var currentDateMilliseconds = new Date().getTime();
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (currentChar) {
                    var randomChar = (currentDateMilliseconds + Math.random() * 16) % 16 | 0;
                    currentDateMilliseconds = Math.floor(currentDateMilliseconds / 16);
                    return (currentChar === 'x' ? randomChar : (randomChar & 0x7 || 0x8)).toString(16);
                });
            };

            var create = function () {
                var hasCrypto = crypto !== 'undefined' && crypto !== null,
                    hasRandomValues = typeof (window.crypto) !== 'undefined' && typeof (window.crypto.getRandomValues) !== 'undefined';
                return (hasCrypto && hasRandomValues) ? _cryptoGuid() : _guid();
            };
             
            return {
                newGuid: create,
                empty: EMPTY
            };
        })();

        return Guid.newGuid();
    }
    //첨부파일 업로드
    static async FileUpLoadModule(apiUrl, jsonStructure) {

        var _SendFilesize = Big3Common.WebConfig.SendFilesize;
        let attribute = {
            FileSeq: null,
            BlobData: null,
            FileSize: null,
            FileName: null,
            FileType: null,
            CrudType: null,
            Guid: null,
            Storage: null,      //저장될 물지적인 공간(옵션:Controller에서 직접 설정할 수 있음.)
            Wmark_Yn: "N",      //이미지 업로드시 워터마크 생성여부(옵션)
            ExtensionAdd: "N"   //첨부파일에 확장자를 붙일지 결정(옵션)
        };

        let Merge = Object.assign(attribute, jsonStructure);           
        try {
            //전송할 원본데이터
            let OriginData = Merge.BlobData.split(',')[1];
            Merge.FileSize = OriginData.length;

            let SendingSize = 0;
            let Sort = 0;
            while (SendingSize < OriginData.length) {
                const chunk = OriginData.slice(SendingSize, SendingSize + _SendFilesize);
                SendingSize = SendingSize + chunk.length;
                Sort = Sort + 1;
                let result = await Big3Common.Post(apiUrl, {
                    sort: Sort,
                    fileseq: Merge.FileSeq,
                    filename: Merge.FileName,
                    filelength: Merge.FileSize,
                    filepos: SendingSize,
                    fileguid: Merge.Guid,
                    storage: Merge.Storage,
                    wmark_yn: Merge.Wmark_Yn,
                    extensionadd: Merge.ExtensionAdd,
                    lastsendyn: Merge.FileSize === SendingSize ? "Y" : "N",
                    data: chunk
                });

                if (result.codeName !== Big3Common.ResultCode.Success) {
                    return false;
                }

            }

        }
        catch (e) {
            console.log("==>업로드 실패", e);
            return false;
        }

        return true;
        
    }
    static WebStorage = {
        StorageName: {
            Sso_ID: "!big3SmartNoteSsoid!",
            FileGrpKey: "!big3SmartNoteFileGrp!",
            StateContent: "!Big3StateContent!",
            OrgName: "OrgName",
            UserName:"UserName",
            LoginYuji: "LoginYuji",
            IsSecondary: "IsSecondary",
            GoodsImageHostName: "!goodsimagehostname!",
            EventImageHostName: "!eventimagehostname!",
            SmartPlatformRTDeviceID: "SmartPlatformRTDeviceID",
            ScrollPosition: "!ScrollPosition!",
            Chat_Identifier: "!Chat_Identifier!",
            Uid_Type:"!Uid_Type!"
        },
        GetLocalStorage: function (key) {
            const Storage = localStorage.getItem(key);
            return Storage;
        },
        SetLocalStorage: function (key, Value) {
            localStorage.setItem(key, Value);
            return false;
        },
        GetSessionStorage: function (key) {
            const Storage = sessionStorage.getItem(key);
            return Storage;
        },
        SetSessionStorage: function (key, Value) {
            sessionStorage.setItem(key, Value);
            return false;
        },
        RemoveSessionStorage: function (key) {
            sessionStorage.removeItem(key);
            return false;
        },
        RemoveStorage: function (key) {
            localStorage.removeItem(key);
            return false;
        },
        StateStorage: function (State, exceptElement = []) {
            //React State 값 복제
            //exceptElement는 복제에서 제외할 List
            let _State = State;
            Object.keys(State).map(key => {
                if (exceptElement.find(element => element === key) !== undefined) {
                    return delete _State[key];
                }
                return null;
            });
            return _State;
        }
    }
    static Util = {
        //Json배열 깊은복사
        Cloen: function (jsonStructure) {
            let source = JSON.stringify(jsonStructure);
            return JSON.parse(source);
        },
        //Json 특정 컬렉션에서 특정 항목을 삭제
        RemoveModelListRow: function (Modelist, DeleteKey, DeleteValue) {
            let idx = Modelist.findIndex((element) => (element[DeleteKey] === DeleteValue));
            if (idx !== -1) {
                Modelist.splice(idx, 1);
            }
            Big3Common.LifeState.ModelUpDate = true;
            return Modelist;
        },
        //핸드폰 형식 검사
        //숫자만 있을때 true
        HandPhoneCheck: function (argNumber) {
            let phoneNum = argNumber.replaceAll('-', '').trim();
            let RegExp = /(01[016789])([1-9]{1}[0-9]{2,3})([0-9]{4})$/;
            if (RegExp.test(phoneNum)) {
                return true;
            }
            else {
                return false;
            }
        },
        //핸드폰 포멧 변경 xxx-xxxx-xxxx
        HandPhoneFormat: function (argNumber) {
            let phoneNum = argNumber.trim();
            phoneNum = phoneNum.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3");
            return phoneNum;   
        },
         //사업자번호 검증
        OrgNumberCheck: function (argNumber) {
            let numberMap = argNumber.replace(/-/gi, '').split('').map(function (d) {
                return parseInt(d, 10);
            });

            if (numberMap.length === 10) {
                var keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
                var chk = 0;
                keyArr.forEach(function (d, i) {
                    chk += d * numberMap[i];
                });

                chk += parseInt((keyArr[8] * numberMap[8]) / 10, 10);
                return Math.floor(numberMap[9]) === ((10 - (chk % 10)) % 10);
            }
            return false;
        },
        //사업자번호 "-" 추가
        OrgNumberFormat: function (argNumber) {
            let orgnumber = argNumber.trim();
            orgnumber = orgnumber.replace(/^(\d{3})(\d{2})(\d{5})$/, "$1-$2-$3");
            return orgnumber;   
        },
        //숫자체크, return/false
        isNumber: function (argNumber) {
            const regex = /^[0-9]+$/;
            if (argNumber.length === 0) {
                return true;
            }
            return regex.test(argNumber);
        },
        //문자열체크(숫자, 특수문자 존재시 false)
        isString: function (argString) {
            const regex = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|]+$/;
            if (argString.length === 0) {
                return true;
            }
            return regex.test(argString);
        },
        //아이디 검증
        isUserIdValid: function (argUserId) {
            const regExp = /^[A-Za-z][A-Za-z0-9]{5,19}$/g;
            if (argUserId.length === 0) {
                return true;
            }
            return regExp.test(argUserId);
        },
         //비밀번호 검증
        isPassWordValid: function (argPWd) {
            const regExp = /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/;
            if (argPWd.length === 0) {
                return true;
            }
            return regExp.test(argPWd);  
        },
        OpenWindowLink: function (url, newTap = false) {
            if (newTap) {
                window.open(url, '_blank');
            }
            else {
                window.location.href = url;
            }
            return false;
        },
        //원단위 표시
        Money: function (txtNumber) {
            try {
                if (txtNumber === null || txtNumber === "") {
                    return 0;
                }
                //let arrNumber = txtNumber.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
                let arrNumber = txtNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return arrNumber;
            }
            catch (e) {
                console.log("Money",e);
                return 0;
            }
            
        },
        SmsSend: function (phoneNumber,Message) {
            const userAgent = navigator.userAgent.toLocaleLowerCase();
            const Phone = phoneNumber.replaceAll("-", "").trim();
            //<a href="sms:/* phone number here */?body=/* body text here */">Link</a>
            if (userAgent.search('android') > -1) {
                window.location.href = `sms:${Phone}?body=${Message}`;
            } else if (userAgent.search('iphone') > -1 || userAgent.search('ipad') > -1) {
                window.location.href = `sms:${Phone}&body=${Message}`;
            }
            return false;
        },
        isEmptyOrNull: function (Value) {
            if (Value === undefined) {
                return true;
            }
            else if (Value === null) {
                return true;
            }
            else if (Value === "") {
                return true;
            }
            else {
                return false;
            }
        },
        groupBy: function (jsonList, GroupKey) {
            const map = new Map();
            jsonList.forEach((item) => {
                const key = GroupKey(item);
                if (!map.has(key)) {
                    map.set(key, [item]);
                } else {
                    map.get(key).push(item);
                }
            });
            return map;
        },
        ByteToKB: function (byte) {
            return Math.ceil((byte / 1024));
        },
        ByteToMb: function (byte) {
            return Math.ceil((byte / 1024/1024));
        },
        offsetWidth: function () {
            //윈도우 너비 반환
            return document.querySelector("#root").offsetWidth;
        },
        DateAdd: function (NowDate, addDay) {
            //특정일자에 일수 추가, NowDate: new Date();
            var today = NowDate;
            var AddDay = NowDate;
            return AddDay.setDate(today.getDate() + addDay);
        },
        GetParams: function (paramName) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const paramValue = urlParams.get(paramName);
            return paramValue;
        },
        GetContentState: function (ContentState, Props, DefaultValue) {
            if (ContentState === undefined || ContentState === null) {
                return DefaultValue;
            }
            else if (ContentState[Props] === undefined) {
                return DefaultValue;
            }
            else {
                return ContentState[Props];
            }
        },
        RemoveLoginStorage: function () {
            //로그아웃 처리 시 스토리지 값 삭제
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.Sso_ID);
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.LoginYuji);
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.OrgName);
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.IsSecondary);
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.UserName);     
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.GoodsImageHostName);    
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.EventImageHostName);    
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.SmartPlatformRTDeviceID);
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.Chat_Identifier);
            Big3Common.WebStorage.RemoveStorage(Big3Common.WebStorage.StorageName.Uid_Type);
            
        },
        LoadingOn: function () {

            const body = document.querySelector("body");
            const myLoading = document.getElementById("myLoading");
            if (myLoading === null) {
                const newDiv = document.createElement("div");
                newDiv.id = "myLoading";
                newDiv.classList.add("loading_wrap");
                let Loading = "";
                Loading += "<div class='dot-wave'>";
                Loading += "<div class='dot-wave__dot'></div>";
                Loading += "<div class='dot-wave__dot'></div>";
                Loading += "<div class='dot-wave__dot'></div>";
                Loading += "<div class='dot-wave__dot'></div>";
                Loading += "</div>";

                newDiv.innerHTML = Loading;
                body.appendChild(newDiv);
            }
            return false;
        },
        LoadingOff: function () {
            const myLoading = document.querySelector("#myLoading");
            if (myLoading !== null) {
                myLoading.remove();
            }
            return false;
        },
        HistoryBack: function (_this) { 
                       
            //헤더의 뒤로가기 버튼의 라우팅 처리
            const ContentState = _this.props.ContentState;            
            if (ContentState === undefined || ContentState === null || ContentState === "") {
                window.history.back(-1);
            }
            else if (ContentState[Big3Common.ContentState.BackUrl] !== undefined && ContentState[Big3Common.ContentState.LinkUrl] === undefined) {
                const Componet = ContentState[Big3Common.ContentState.BackUrl];
                delete ContentState[Big3Common.ContentState.BackUrl];
                _this.props.RenderComponent(Componet, ContentState);
            }
            else if (ContentState[Big3Common.ContentState.LinkUrl] !== undefined && ContentState[Big3Common.ContentState.BackUrl] === undefined) {
                const LinkUrl = ContentState[Big3Common.ContentState.LinkUrl];
                delete ContentState[Big3Common.ContentState.LinkUrl];
                window.location.href = LinkUrl;
            }
            else {
                window.history.back(-1);
            }
            return false;
        }
    }

    //브라우저, 모바일의 뒤로가기 버큰을 클릭 할때 backdrop이 있으면 제거
    static HistoryBackToClearBackdoor() {

        const backdrop = document.getElementsByClassName("modal-backdrop");
        if (backdrop.length > 0) {
            Array.from(backdrop).forEach(drop => {
                drop.remove();
            });

            //부트스트랩에서 body에 시간차를 두고 style를 변경
            setTimeout(() => {
                const Body = document.querySelector("body");
                Array.from(Body.style).forEach(styleName => {
                    Body.style.removeProperty(styleName);
                })
            }, 1000);
        }       
        return false;
    }
    //상품리스트에서 상품상세를 레이어로 보여줄때
    //isShow=true 이면 상세페이지 보여주고, false이면 리스트 페이지를 보여줌
    //headHide=true이면 특정 헤드를 보여주고, false이면 보여주지 않음.
    //child_dtl_id= child_goods_dtl or smilar_child_goods_dtl 일수 있음.
    static GoodsDtl_ShowHide(isShow, headHide) {
        console.log("headHide", headHide);
        if (isShow) {
            Big3Common.WebConfig.ScrollEvent = false;
            let ScrollPosition = window.scrollY;
            if (ScrollPosition > 0) {
                Big3Common.WebStorage.SetSessionStorage(Big3Common.WebStorage.StorageName.ScrollPosition, ScrollPosition);
            }
            //헤더가 2개로 겹칠경우 최상단 헤더 히든처리
            document.getElementById("parent_goods_list").className = "item_hide";
            if (headHide) {

                document.querySelector("header").className = "item_hide";
            }
            document.getElementById("child_goods_dtl").classList.remove("item_hide");
            window.scrollTo(0, 0);
        }
        else {
            let ScrollPosition = Big3Common.WebStorage.GetSessionStorage(Big3Common.WebStorage.StorageName.ScrollPosition);
            document.getElementById("parent_goods_list").classList.remove("item_hide");
            if (document.querySelector("#parent_goods_list > header") && document.querySelector("#parent_goods_list > header").className === "item_hide") {
               document.querySelector("#parent_goods_list > header").classList.remove("item_hide");
            }
            //히든된 헤더 다시 복귀
            if (document.querySelector("header").className === "item_hide") {
                document.querySelector("header").classList.remove("item_hide");
            }
            setTimeout(() => {
                if (document.getElementById("child_goods_dtl")) {
                    document.getElementById("child_goods_dtl").className = "item_hide";
                }
                window.scrollTo({
                    top: ScrollPosition,
                    left: 0,
                    behavior: "instant",
                });

            }, 100);
            Big3Common.WebConfig.SimilarUseYn = "N";
            Big3Common.WebConfig.ScrollEvent = true;
        }
    }
    //메인페이지, 이벤트페이지의 사용자 추적 로그
    static RegisterTrackingLog(jsonObject) {
        try {

            const pathName = window.document.location.pathname.toLowerCase();
            if (jsonObject.Basket_Yn === "Y") {
                //장바구니 로그 등록 시
                if (pathName === "/" || pathName === "/admgr/sepecialevent" || pathName === "/admgr/listgoodsmore") {
                    const mgr_no = Big3Common.Util.GetParams("mgr_no");
                    jsonObject.Mgr_No = mgr_no;
                }
                else {
                    return false;
                }
            }
            Big3Common.Post("api/Common/Common/RegisterTrackingLog", jsonObject , true);
        }
        catch (e) {
            console.log("RegisterTrackingLog", e);
        }
    }
}
